import { SearchIcon } from "lucide-react";
import { useState } from "react";
import { useDebounce } from "react-use";
import { Input } from "../ui/input";

type SearchInputProps = {
  setSearch: (label: string) => void;
  className?: string;
};

const DEBOUNCE_DELAY = 200; // milliseconds

export const SearchInput = ({ setSearch, className }: SearchInputProps) => {
  const [value, setValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  useDebounce(
    () => {
      setSearch(value);
    },
    DEBOUNCE_DELAY,
    [value],
  );

  return (
    <div
      className={`rounded-lg border flex items-center bg-white px-2 py-0.5 transition-all ${
        isFocused
          ? "border-[2px] border-[#758FFF] h-[64px] rounded-2xl"
          : "border-[1px] border-[#E7EBEE] h-[42px] rounded-full"
      } ${className ?? ""}`.trim()}
    >
      <SearchIcon className="text-light-gray" />

      <Input
        className="border-none ring-0 text-sm focus:ring-0 focus-visible:ring-0 shadow-none"
        placeholder="クイズを検索"
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        value={value}
      />
    </div>
  );
};
